import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@shared/lib';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  interactive?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const paddingMap = {
  none: 'p-0',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

export function Card({ className, interactive, padding = 'md', children, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-card border border-transparent bg-card transition-colors',
        paddingMap[padding],
        interactive && 'cursor-pointer hover:border-line',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
}

interface CardKickerProps {
  children: ReactNode;
  className?: string;
}

Card.Kicker = function CardKicker({ children, className }: CardKickerProps) {
  return (
    <div className={cn('mb-3 text-[12px] font-medium uppercase tracking-[0.16em] text-muted', className)}>
      {children}
    </div>
  );
};

Card.Value = function CardValue({ children, className }: CardKickerProps) {
  return (
    <div className={cn('font-serif text-[44px] font-medium leading-none tracking-[-0.02em]', className)}>
      {children}
    </div>
  );
};

Card.Small = function CardSmall({ children, className }: CardKickerProps) {
  return <div className={cn('mt-2 text-xs text-muted', className)}>{children}</div>;
};
